package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.columnGap
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import io.horion.cv.utils.Constants.UBUNTU
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

val SignatureFormStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
    }
}

val SignatureFieldsContainerStyle = CssStyle {
    base {
        Modifier
            .padding(bottom = 15.px)
    }

    Breakpoint.MD {
        Modifier.padding(bottom = 25.px)
    }
}

val SignatureFieldInputStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .minWidth(0.px)
    }
}

val SignatureDateInputStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .minWidth(0.px)
    }
}

val SignatureLabelStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.px)
            .fontFamily(INTER)
            .fontWeight(FontWeight.Light)
    }

    Breakpoint.MD {
        Modifier.fontSize(16.px)
    }
}

val SignatureBoxStyle = CssStyle {
    base {
        Modifier
            .width(280.px)
            .height(150.px)
            .borderRadius(8.px)
            .cursor(Cursor.Pointer)
    }

    Breakpoint.MD {
        Modifier
            .width(380.px)
            .height(180.px)
    }
}

val SignaturePlaceholderIconStyle = CssStyle {
    base {
        Modifier.size(22.px)
    }

    Breakpoint.MD {
        Modifier.size(30.px)
    }
}

val SignatureModalContainerStyle = CssStyle {
    base {
        Modifier
            .width(100.percent)
            .maxWidth(380.px)
            .padding(12.px)
            .borderRadius(12.px)
    }

    Breakpoint.MD {
        Modifier
            .width(100.percent)
            .maxWidth(700.px)
            .padding(25.px)
    }
}

val SignatureModalTitleStyle = CssStyle {
    base {
        Modifier
            .fontSize(18.px)
            .fontFamily(INTER)
            .fontWeight(FontWeight.Bold)
    }

    Breakpoint.MD {
        Modifier.fontSize(26.px)
    }
}

val SignatureCloseButtonStyle = CssStyle {
    base {
        Modifier
            .size(30.px)
            .borderRadius(5.px)
            .cursor(Cursor.Pointer)
    }

    Breakpoint.MD {
        Modifier.size(40.px)
    }
}

val SignatureCloseIconStyle = CssStyle {
    base {
        Modifier.size(18.px)
    }

    Breakpoint.MD {
        Modifier.size(25.px)
    }
}

val SignatureModalFirstSpacerStyle = CssStyle {
    base {
        Modifier.height(20.px)
    }

    Breakpoint.MD {
        Modifier.height(40.px)
    }
}

val SignatureModalSecondSpacerStyle = CssStyle {
    base {
        Modifier.height(16.px)
    }

    Breakpoint.MD {
        Modifier.height(30.px)
    }
}

val SignatureActionsRowStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .flexWrap(FlexWrap.Wrap)
            .columnGap(10.px)
    }

    Breakpoint.MD {
        Modifier
            .columnGap(25.px)
    }
}

val SignatureActionsGroupStyle = CssStyle {
    base {
        Modifier
    }

    Breakpoint.MD {
        Modifier
    }
}

val SignatureColorGroupStyle = CssStyle {
    base {
        Modifier
    }
}

val EraseButtonStyle = CssStyle {
    base {
        Modifier
            .padding(
                topBottom = 6.px,
                leftRight = 8.px
            )
            .borderRadius(8.px)
            .cursor(Cursor.Pointer)
    }

    Breakpoint.MD {
        Modifier.padding(
            topBottom = 10.px,
            leftRight = 15.px
        )
    }
}

val EraseIconStyle = CssStyle {
    base {
        Modifier.size(16.px)
    }

    Breakpoint.MD {
        Modifier.size(25.px)
    }
}

val EraseTextStyle = CssStyle {
    base {
        Modifier
            .fontSize(12.px)
            .fontFamily(INTER)
    }

    Breakpoint.MD {
        Modifier.fontSize(20.px)
    }
}

val FinishButtonStyle = CssStyle {
    base {
        Modifier
            .padding(10.px)
            .borderRadius(8.px)
            .display(DisplayStyle.Flex)
            .justifyContent(JustifyContent.Center)
            .alignItems(AlignItems.Center)
            .backgroundColor(Colors.BlueLight)
    }

    Breakpoint.MD {
        Modifier.padding(25.px)
    }
}

val FinishButtonTextStyle = CssStyle {
    base {
        Modifier
            .fontSize(13.px)
            .color(Colors.White)
            .fontFamily(INTER)
    }

    Breakpoint.MD {
        Modifier.fontSize(16.px)
    }
}

val SignatureTabTextStyle = CssStyle {
    base {
        Modifier
            .fontSize(13.px)
            .fontFamily(UBUNTU)
    }

    Breakpoint.MD {
        Modifier.fontSize(18.px)
    }
}

val DrawingCanvasStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .height(200.px)
            .borderRadius(10.px)
            .overflow(Overflow.Hidden)
    }

    Breakpoint.MD {
        Modifier.height(300.px)
    }
}

val FontSelectorButtonStyle = CssStyle {
    base {
        Modifier
            .padding(
                topBottom = 6.px,
                leftRight = 8.px
            )
            .borderRadius(8.px)
            .cursor(Cursor.Pointer)
    }

    Breakpoint.MD {
        Modifier.padding(
            topBottom = 12.px,
            leftRight = 16.px
        )
    }
}

val FontSelectorTextStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.px)
            .fontFamily(INTER)
    }

    Breakpoint.MD {
        Modifier.fontSize(20.px)
    }
}

val FontSelectorArrowStyle = CssStyle {
    base {
        Modifier.size(12.px)
    }

    Breakpoint.MD {
        Modifier.size(20.px)
    }
}

val ColorDotStyle = CssStyle {
    base {
        Modifier
            .size(22.px)
            .borderRadius(50.px)
            .cursor(Cursor.Pointer)
    }

    Breakpoint.MD {
        Modifier.size(30.px)
    }
}

val ColorDotCheckIconStyle = CssStyle {
    base {
        Modifier.size(12.px)
    }

    Breakpoint.MD {
        Modifier.size(16.px)
    }
}

val SignatureFieldsMobileStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .display(DisplayStyle.Flex)
    }

    Breakpoint.LG {
        Modifier.display(DisplayStyle.None)
    }
}

val SignatureFieldsDesktopStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .display(DisplayStyle.None)
    }

    Breakpoint.LG {
        Modifier
            .fillMaxWidth()
            .display(DisplayStyle.Flex)
    }
}

val SignatureActionsSpacingStyle = CssStyle {
    base {
        Modifier.columnGap(10.px)
    }

    Breakpoint.MD {
        Modifier.columnGap(25.px)
    }
}

val SignatureColorsSpacingStyle = CssStyle {
    base {
        Modifier.columnGap(10.px)
    }
}

val EraseContentSpacingStyle = CssStyle {
    base {
        Modifier.columnGap(5.px)
    }
}

val FontSelectorSpacingStyle = CssStyle {
    base {
        Modifier.columnGap(4.px)
    }

    Breakpoint.MD {
        Modifier.columnGap(10.px)
    }
}
